import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {CaseDTO} from '../models/CaseDTO';
import {CaseFuneralDTO} from '../models/CaseFuneralDTO';
import {CaseHospitalDTO} from '../models/case-hospital/CaseHospitalDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ContactDTO} from '../../ent/models/ContactDTO';
import {IssueTicketCaseLinkDTO} from '../models/IssueTicketCaseLinkDTO';

@Injectable({
  providedIn: 'root'
})
export class CaseService {
  private url = environment.baseClmUrl + '/case';
  private pbmUrl = environment.baseUrl;

  constructor(private httpClient: HttpClient) {
  }

  getInsuredPersonLinkedFuneralCases(insuredPersonId: number): Observable<CaseFuneralDTO[]> {
    const params = new HttpParams()
      .set('insuredPersonId', String(insuredPersonId));

    return this.httpClient.get<CaseFuneralDTO[]>(this.url + '-funeral/byInsuredPersonId', {params});
  }

  getInsuredPersonLinkedHospitalCases(insuredPersonId: number): Observable<CaseHospitalDTO> {
    const params = new HttpParams()
      .set('insuredPersonId', String(insuredPersonId));

    return this.httpClient.get<CaseHospitalDTO>(this.url + '-hospital/byInsuredPersonId', {params});
  }

  getListOfCases(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<CaseDTO>> {
    return this.httpClient.post<PagedResponseDTO<CaseDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getContactByInsuredPerson(personId: number): Observable<ContactDTO> {
    return this.httpClient.get<ContactDTO>(this.pbmUrl + `/contact/byPersonId?personId=${personId}`);
  }

  createTicket(issueTicketCaseLinkDTO: IssueTicketCaseLinkDTO): Observable<IssueTicketCaseLinkDTO> {
    return this.httpClient.post<IssueTicketCaseLinkDTO>(this.url + '/ticket', issueTicketCaseLinkDTO);
  }

  deleteTicket(caseId: bigint, ticketId: bigint): Observable<IssueTicketCaseLinkDTO> {
    return this.httpClient.delete<IssueTicketCaseLinkDTO>(this.url + '/ticket', {
      params: {
        caseId: String(caseId),
        ticketId: String(ticketId)
      }
    });
  }

  getCaseCount(managerName: string, status: string): Observable<number> {
    const params = new HttpParams()
      .set('managerName', String(managerName))
      .set('status', String(status));

    return this.httpClient.get<number>(this.url + '/count', {params});
  }

}
